import { Map } from "immutable";
import * as React from "react";
import { AsyncState, fromJSX, Widget } from "widgets-for-react";
import { ImageSize, Url } from "../types.gen";

export function ModernImageContainer (
  url: AsyncState<Map<ImageSize, Url>>,
  className: string,
  alt: string,
  get_default_data_src:(() => ImageSize),
  get_default_data_srcset:(() => [ImageSize, string][]),
  dataSizes?: string,
  lazyload?: boolean,
  width?: string,
  height?: string
): Widget<never> {
  return fromJSX(() =>
    url.kind === "loaded"
      ? (
        <img
          loading={lazyload == false ? 'eager' : 'lazy'}
          width={width || undefined}
          height={height || undefined}
          src={url.value.get(get_default_data_src())}
          sizes={dataSizes ? dataSizes : '100vw'}
          srcSet={get_default_data_srcset().map(e => `${url.value.get(e[0])} ${e[1]}`).join(",")}
          className={className}
          alt={alt}
        />
      )
      : <></>
  )
}
